import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'maxGuestEndAgeForRateDisabled' })
export class MaxGuestEndAgeForRateDisabledPipe implements PipeTransform {
  transform(startAge: number): boolean {
    return Number.isNaN(startAge);
  }
}
